/*
* Copyright (c) 2025 SGS Europe. All rights reserved.
*
* This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
* Any unauthorised use, reproduction, or transfer of this program is strictly
* prohibited.
*
* File Name: AnnotationTextClassification.js
*
* Description: JavaScript code for the text classification annotation functionality.
*
*/

var g_oAnnotationTextClassification = {};

(function () {
	"use strict";

	/**
	 * Create the Annotation Text Classification object.
	 */
	function AnnotationTextClassification(oSnapdragonData) {

		// Set the snapdragon data.
		this.g_oSnapdragonData = oSnapdragonData;

		// Set the visibility of the text classification icon.
		if (this.g_oSnapdragonData != null) {
			this.showTextClassificationAnnotationType();
		}
		else {
			this.hideTextClassificationAnnotationType();
		}

		// Set the JQTE allowed options for text classification annotations.
		this.g_oJQTEOptions = {
			"br": true,
			"b": true,
			"i": true,
			"center": false,
			"color": false,
			"format": false,
			"indent": false,
			"link": false,
			"left": false,
			"outdent": false,
			"ol": false,
			"p": false,
			"remove": false,
			"right": false,
			"rule": false,
			"source": false,
			"title": false,
			"unlink": false,
			"fsize": false,
			"fsizes": false,
			"sub": false,
			"strike": false,
			"sup": false,
			"u": false,
			"ul": false
		};
	};

	/**
	 * Renders the annotations text classification content.
	 * @param {any} oAnnotation - The annotation.
	 * @param {any} oArtworkCanvas - The artwork canvas.
	 * @param {any} oContainer - The container.
	 */
	AnnotationTextClassification.prototype.renderAnnotationTextClassificationContent = function (oAnnotation, oArtworkCanvas, oContainer) {
		
		// Create the text classification header.
		var oTextClassificationHeader = document.createElement("p");
		oTextClassificationHeader.innerHTML = "Text Classification";
		oTextClassificationHeader.className = "HeaderText";
		oContainer.appendChild(oTextClassificationHeader);

		// Create the editable text classification input area.
		if (oAnnotation.id < 0) {
			g_oAnnotationTextClassification.createEditableTextClassificationData(oAnnotation, oContainer, false);
		}
		// Create the read only text classification input area.
		else {
			g_oAnnotationTextClassification.createReadOnlyTextClassificationData(oAnnotation, oArtworkCanvas, oContainer, false);
		}

		// Create the text classification value header.
		var oTextClassificationValueHeader = document.createElement("p");
		oTextClassificationValueHeader.innerHTML = "Value";
		oTextClassificationValueHeader.className = "HeaderText";
		oContainer.appendChild(oTextClassificationValueHeader);
	};

	/**
	 * Creates the read only text classification data.
	 * @param {any} oAnnotation - The annotation.
	 * @param {any} oArtworkCanvas - The artwork canvas.
	 * @param {any} oContainer - The container.
	 * @param {any} bReplaceContainer - If the container should be replaced.
	 */
	AnnotationTextClassification.prototype.createReadOnlyTextClassificationData = function (oAnnotation, oArtworkCanvas, oContainer, bReplaceContainer) {

		// Determine if this is a list item or popup.
		var bListItem = ($(oContainer).parents(".annotationListItem").length > 0);

		// Build the id for the text classification data.
		var textClassificationId = oAnnotation.id + "_textClassificationData" + (bListItem ? "_list" : "_popup");

		// Create the input element.
		var input = document.createElement("p");
		input.id = textClassificationId;
		input.setAttribute("data-dbId", textClassificationId);
		input.className = "ReadOnlyAnnotationText";

		// Build the text content.
		var szTextContent = "<span><b>Tag:</b> " + oAnnotation.g_oAnnotationData.Tag + "</span><br/>";
		szTextContent += "<span><b>Language:</b> " + oAnnotation.g_oAnnotationData.Language + "</span><br/>";
		szTextContent += "<span><b>Sequence:</b> " + oAnnotation.g_oAnnotationData.Sequence + "</span>"

		// Set the text content.
		input.innerHTML = szTextContent;

		// Internet Explorer 6-11
		var bIE = false || !!document.documentMode;
		// Edge 20+
		var bEdge = !bIE && !!window.StyleMedia;
		if (!bIE && !bEdge) {
			input.dir = "auto";
		}

		// Update the speech bubble copy functionality.
		$(".speechbubble").off('copy');
		$(".speechbubble").on('copy', function (event) { AnnotationUI.prototype.copyOverride(event); });
		
		// We show the edit option if the user has an open approval slot and this is not a new annotation or an annotation status.
		// And they created the annotation, this is an unlocked annotation, or this is an svg text annotation which the user has permissions to edit.
		if (oAnnotation.g_iApprovalId === g_oAnnotations.g_iApprovalId && !g_oViewer.g_bReadOnly && oArtworkCanvas.g_bMainCanvas && oAnnotation.id > 0) {
			if ((oAnnotation.g_iAuthor === g_oUserDetails.UserId || oAnnotation.g_bUnlocked)) {
				addDomElement("eb_" + textClassificationId, "input", "img/Edit_Wht_16.png", "editAnnotationDataButton", "Edit Classification Data", g_oAnnotationTextClassification.editTextClassificationData, input);
			}
		}

		// Replace the container.
		if (bReplaceContainer) {
			oContainer.replaceWith(input);
		}
		// Append to the container.
		else {
			oContainer.appendChild(input);
		}
	};

	/**
	 * Creates the editable text classification data.
	 * @param {any} oAnnotation - The annotation.
	 * @param {any} oContainer - The container.
	 * @param {any} bReplaceContainer - If the container should be replaced.
	 */
	AnnotationTextClassification.prototype.createEditableTextClassificationData = function (oAnnotation, oContainer, bReplaceContainer) {

		// If the annotation slide out is collapsed, open it.
		if (g_oSettings.g_oUserSettings.LeftMenuCollapse) {

			// Slide the menu to the correct position.
			slideDiv($("#divAnnotationsContainer"), true, true);
		}

		// We only allow editing of text classification data on list items.
		var bListItem = ($(oContainer).parents(".annotationListItem").length > 0);

		// Build the id for the text classification data.
		var textClassificationId = oAnnotation.id + "_textClassificationData" + (bListItem ? "_list" : "_popup");

		// Create the input element.
		var input = document.createElement("p");
		input.id = textClassificationId;
		input.setAttribute("data-dbId", textClassificationId);
		input.className = "TextClassificationAnnotationText";

		// Build the editable content.
		var szContent = "";
		szContent += "<div style='margin-top: 4px; margin-bottom: 4px;'><div style='font-weight: bold; margin-bottom: 2px;'>Tag:</div>" + g_oAnnotationTextClassification.createTextClassificationTagSelectList(textClassificationId + "_Tag", oAnnotation.g_oAnnotationData.Tag, "width: 100%;") + "</div>";
		szContent += "<div style='margin-top: 4px; margin-bottom: 4px;'><div style='font-weight: bold; margin-bottom: 2px;'>Language:</div>" + g_oAnnotationTextClassification.createTextClassificationLanguageSelectList(textClassificationId + "_Language", oAnnotation.g_oAnnotationData.Language, "width: 100%;") + "</div>";
		szContent += "<div style='margin-top: 4px; margin-bottom: 4px;'><div style='font-weight: bold; margin-bottom: 2px;'>Sequence:</div>" + g_oAnnotationTextClassification.createTextClassificationSequenceSelectList(textClassificationId + "_Sequence", oAnnotation.g_oAnnotationData.Sequence, "width: 100%;") + "</div>";

		// Set the text content.
		input.innerHTML = szContent;

		// Internet Explorer 6-11
		var bIE = false || !!document.documentMode;
		// Edge 20+
		var bEdge = !bIE && !!window.StyleMedia;
		if (!bIE && !bEdge) {
			input.dir = "auto";
		}

		// Update the speech bubble copy functionality.
		$(".speechbubble").off('copy');
		$(".speechbubble").on('copy', function (event) { AnnotationUI.prototype.copyOverride(event); });

		// Add the save option.
		if (oAnnotation.id > 0) {
			addDomElement("sb_" + textClassificationId, "input", "img/Save_wht_16.png", "saveAnnotationDataButton", "Save Classification Data", g_oAnnotationTextClassification.saveTextClassificationData, input);
		}

		// Replace the container.
		if (bReplaceContainer) {
			oContainer.replaceWith(input);
		}
		// Append to the container.
		else {
			oContainer.appendChild(input);
		}

		// If this is a popup area, prevent the drag & drop cursor on the content.
		if (!bListItem) {
			$('#' + textClassificationId).css('cursor', "default");
		}
	};

	/**
	 * Creates the text classification tag select list.
	 * @param {any} szId - The id of the select list.
	 * @param {any} szValue - The value of the select list.
	 * @param {any} szStyle - The style of the select list.
	 */
	AnnotationTextClassification.prototype.createTextClassificationTagSelectList = function (szId, szValue, szStyle) {

		// Build up the content of the select list.
		var szContent = "";
		szContent += "<select id='" + szId + "' style='" + szStyle + "'>"

		// Get the values to be added to the select list.
		var oSelectListValues = g_oAnnotationTextClassification.g_oSnapdragonData.SnapdragonTags;

		// Add each of the values.
		for (var i = 0; i < oSelectListValues.length; i++) {
			szContent += "<option value='" + oSelectListValues[i].TagName + "'" + (oSelectListValues[i].TagName == szValue ? " selected" : "") + ">" + oSelectListValues[i].TagName + "</option>";
		}

		// Close the content of the select list.
		szContent += "</select>";

		// Return the content.
		return szContent;
	};

	/**
	 * Creates the text classification language select list.
	 * @param {any} szId - The id of the select list.
	 * @param {any} szValue - The value of the select list.
	 * @param {any} szStyle - The style of the select list.
	 */
	AnnotationTextClassification.prototype.createTextClassificationLanguageSelectList = function (szId, szValue, szStyle) {

		// Build up the content of the select list.
		var szContent = "";
		szContent += "<select id='" + szId + "' style='" + szStyle + "'>"

		// Get the values to be added to the select list.
		var oSelectListValues = g_oAnnotationTextClassification.g_oSnapdragonData.SnapdragonLanguages;

		// Add each of the values.
		for (var i = 0; i < oSelectListValues.length; i++) {
			szContent += "<option value='" + oSelectListValues[i].CustomLanguageName + "'" + (oSelectListValues[i].CustomLanguageName == szValue ? " selected" : "") + ">" + oSelectListValues[i].CustomLanguageName + "</option>";
		}

		// Close the content of the select list.
		szContent += "</select>";

		// Return the content.
		return szContent;
	};

	/**
	 * Creates the text classification sequence select list.
	 * @param {any} szId - The id of the select list.
	 * @param {any} szValue - The value of the select list.
	 * @param {any} szStyle - The style of the select list.
	 */
	AnnotationTextClassification.prototype.createTextClassificationSequenceSelectList = function (szId, szValue, szStyle) {

		// Build up the content of the select list.
		var szContent = "";
		szContent += "<select id='" + szId + "' style='" + szStyle + "'>"

		// Get the current value to be added to the select list.
		var iCurrentSequenceValue = parseInt(szValue);

		// Add each of the values.
		for (var i = 1; i <= iCurrentSequenceValue + 1; i++) {
			szContent += "<option value='" + i + "'" + (i == iCurrentSequenceValue ? " selected" : "") + ">" + i + "</option>";
		}

		// Close the content of the select list.
		szContent += "</select>";

		// Return the content.
		return szContent;
	};

	/**
	 * Edits the text classification data.
	 * @param {any} e - The event.
	 */
	AnnotationTextClassification.prototype.editTextClassificationData = function (e) {

		// Stop the defult click behaviours.
		e.preventDefault();
		e.stopPropagation();

		// Ensure we have snapdragon data to perform the edit.
		if (g_oAnnotationTextClassification.g_oSnapdragonData == null) {
			g_oGreenlightMessages.displayErrorBubble("Snapdragon data missing, unable to perform the edit.");
			return;
		}

		// Ensure we are not already editing text annotation content.
		if ($(".jqte").length > 0) {
			g_oGreenlightMessages.displayErrorBubble("Please save any outstanding changes to text content.");
			return;
		}

		// Ensure we are not already editing text classification data.
		if ($(".saveAnnotationDataButton").length > 0) {
			g_oGreenlightMessages.displayErrorBubble("Please save any outstanding changes to text classifications.");
			return;
		}

		// Grab the various elements of the edit button we just clicked on.
		var relatedAnnotationId;
		var relatedAnnotationDiv = $(this).parents(".speechbubble");
		var relatedAnnotationListItem = $(this).parents(".annotationListItem");

		// If we have clicked the edit button from an annotation div.
		if (relatedAnnotationDiv.length === 0) {
			relatedAnnotationId = parseInt(relatedAnnotationListItem[0].id.substring(3), 10);
		}
		// If we have clicked the edit button from an annotation list item.
		else {
			relatedAnnotationId = parseInt(relatedAnnotationDiv[0].id, 10);
		}

		// Find the annotation.
		var relatedAnnotation = $.grep(g_oAnnotations.g_oAnnotationsMade, function (ann) { return ann.id == relatedAnnotationId; })[0];

		// Determine if this is a list item or popup.
		var bListItem = ($(e.target).parents(".annotationListItem").length > 0);

		// Build the id for the text classification data.
		var textClassificationId = relatedAnnotation.id + "_textClassificationData" + (bListItem ? "_list" : "_popup");

		// Get the target.
		var textClassificationContainer = document.getElementById(textClassificationId);

		// Render the editable text classification data.
		g_oAnnotationTextClassification.createEditableTextClassificationData(relatedAnnotation, textClassificationContainer, true);

		// Scroll to the edited annotaton item in the list.
		Annotation.prototype.scrollEditAnnotation(relatedAnnotation);
	};

	/**
	 * Saves the text classification data.
	 * @param {any} e - The event.
	 */
	AnnotationTextClassification.prototype.saveTextClassificationData = function(e) {

		// Stop the defult click behaviours.
		e.preventDefault();
		e.stopPropagation();
		
		// Determine if this is a list item or popup.
		var bListItem = ($(e.target).parents(".annotationListItem").length > 0);

		// Get the artwork canvas.
		var oArtworkCanvas = g_oViewer.getCanvas("ArtworkViewer");

		// Grab the various elements of the edit button we just clicked on.
		var relatedAnnotationId;
		var relatedAnnotationDiv = $(this).parents(".speechbubble");
		var relatedAnnotationListItem = $(this).parents(".annotationListItem");

		// If we have clicked the edit button from an annotation div.
		if (relatedAnnotationDiv.length === 0) {
			relatedAnnotationId = parseInt(relatedAnnotationListItem[0].id.substring(3), 10);
		}
		// If we have clicked the edit button from an annotation list item.
		else {
			relatedAnnotationId = parseInt(relatedAnnotationDiv[0].id, 10);
		}

		// Find the annotation.
		var relatedAnnotation = $.grep(g_oAnnotations.g_oAnnotationsMade, function (ann) { return ann.id == relatedAnnotationId; })[0];

		// Build the id for the text classification data.
		var textClassificationId = relatedAnnotation.id + "_textClassificationData" + (bListItem ? "_list" : "_popup");

		// Get the target.
		var textClassificationContainer = document.getElementById(textClassificationId);

		// Update the annotation data.
		g_oAnnotationTextClassification.updateAnnotationTextClassificationData(relatedAnnotation, bListItem);

		// Update the annotation status.
		relatedAnnotation.status = "u";

		// Render the readonly text classification data.
		g_oAnnotationTextClassification.createReadOnlyTextClassificationData(relatedAnnotation, oArtworkCanvas, textClassificationContainer, true);

		// Save the annotation.
		relatedAnnotation.AnnotationSave(0, oArtworkCanvas, oArtworkCanvas.g_oAnnotationCanvas, false);
	};

	AnnotationTextClassification.prototype.updateAnnotationTextClassificationData = function (oAnnotation, bListItem) {

		// Build the id for the text classification data.
		var textClassificationId = oAnnotation.id + "_textClassificationData" + (bListItem ? "_list" : "_popup");

		// Update the annotation data.
		oAnnotation.g_oAnnotationData.Tag = $("#" + textClassificationId + "_Tag").val();
		oAnnotation.g_oAnnotationData.Language = $("#" + textClassificationId + "_Language").val();
		oAnnotation.g_oAnnotationData.Sequence = parseInt($("#" + textClassificationId + "_Sequence").val());
	};

	/**
	 * Populates the default annotation data for a text classification annotation.
	 * @returns - The default annotation data.
	 */
	AnnotationTextClassification.prototype.populateDefaultAnnotationData = function () {

		// Ensure we have snapdragon data to populate.
		if (g_oAnnotationTextClassification.g_oSnapdragonData == null) {
			return null;
		}

		// Return the default annotation data.
		return {
			Tag: g_oAnnotationTextClassification.g_oSnapdragonData.SnapdragonTags[0].TagName,
			Language: g_oAnnotationTextClassification.g_oSnapdragonData.SnapdragonLanguages[0].CustomLanguageName,
			Sequence: 1,
			AdditionalData: null
		};
	};

	/**
	 * Shows the text classification annotation type.
	 */
	AnnotationTextClassification.prototype.showTextClassificationAnnotationType = function () {
		$("#TextClassification").removeClass("annotationTypeHidden");
	};

	/**
	 * Hides the text classification annotation type.
	 */
	AnnotationTextClassification.prototype.hideTextClassificationAnnotationType = function () {
		$("#TextClassification").addClass("annotationTypeHidden");
	};

	/**
	 * Add the AnnotationTextClassification object to the window.
	 */
	window.AnnotationTextClassification = AnnotationTextClassification;

}());